<template>
  <div v-if="loading">
    <div class="loading">
      <div class="loader" />
    </div>
    <!-- <button @click="fillData()">Randomize</button> -->
  </div>

  <div
    v-else
    class="small"
  >
    <line-chart
      :chart-data="datacollection"
      :options="options"
    />
    <!-- <button @click="fillData()">Randomize</button> -->
    <div class="md-layout-item md-size-100 text-right">
      <md-button
        class="md-raised md-success"
        @click="selectChoice(0)"
      >
        Útima Hora
      </md-button>
      <md-button
        class="md-raised md-success"
        @click="selectChoice(1)"
      >
        Útimo Dia
      </md-button>
      <!-- <md-button class="md-raised md-success"  @click="selectChoice(2)">Útima Semana</md-button>
      <md-button class="md-raised md-success"  @click="selectChoice(3)">Útimo Mês</md-button> -->
    </div>
  </div>
</template>

<script>
  import LineChart from "../util/LineChart.js";
  // Chart.defaults.scale.gridLines.display = false;
  import { userService } from "../_services";

  export default {
    components: {
      LineChart
    },
    data () {
      return {
        datacollection: null,
        options: null,
        id: 0,
        sites:[],
        item:null,
        host:null,
        application:null,
        site:null,
        label:null,
        loading: true,
        time_object:[{time:3600, quantity:120,name:"lasthour", lquantity:6},
        {time:86400, quantity:2880,name:"lastday", lquantity:12},
        {time:604800, quantity:20160,name:"lastweek", lquantity:6},
        {time:241920, quantity:80640,name:"lastmonth", lquantity:4}],
        time_selection:0,
        label_array:[],
        value_array:[]


      };
    },
    mounted () {
      this.returnUrl = this.$route.query.returnUrl || "/cockpit";
      this.id = this.$route.params.id;
      this.sites = JSON.parse(localStorage.getItem("sites"));
      var i=0,j=0,k=0,l=0;
      for(i=0;i<this.sites.length;i++){
        for(j=0;j<this.sites[i].hosts.length;j++){
          for(k=0;k<this.sites[i].hosts[j].applications.length;k++){
            for(l=0;l<this.sites[i].hosts[j].applications[k].itens.length;l++){
              if(this.sites[i].hosts[j].applications[k].itens[l].id==this.id){
                this.item=this.sites[i].hosts[j].applications[k].itens[l];
                this.application=this.sites[i].hosts[j].applications[k];
                this.host=this.sites[i].hosts[j];
                this.site=this.sites[i];
              }
            }
          }
        }
      }
      if(this.item==null){
        this.$router.push(this.returnUrl);
      }
      else{
        this.label="["+this.site.site + "] ["+  this.host.name.substring(this.host.name.indexOf("_")+1,this.host.name.length)+ "] "+ this.application.name + " : "+this.item.name+" ("+ this.item.units+")";
        // console.log(this.item);
        this.getUpdatedValues();


      }
    },
    methods: {
      getUpdatedValues(){
        this.label_array=[];
        this.value_array=[];
        let time_from = { seconds: (Date.now()/ 1000) - this.time_object[this.time_selection].time, nanoseconds: 0 };
        var time_from_int=Math.round( time_from.seconds );
        var time_step_int=Math.round(this.time_object[this.time_selection].time/this.time_object[this.time_selection].quantity);
        // console.log("Time Step="+time_step_int)
        // console.log(time_from_int.toString())
        // Get latest values
        userService.ItemHistoryZabbix(this.site, this.item.id.toString(), time_from_int.toString(), this.time_object[this.time_selection].quantity.toString()).then(zabbixItemHistory => {
          var i =0,j=0,finalseconds=0,seconds=0, minutes=0,hours=0,days=0,date=null,swapclock,t1=0,t2=0,dateString=null;
          // console.log(zabbixItemHistory);
          for(i=zabbixItemHistory.length-1;i>-1;i--){
            // var A=(parseInt(zabbixItemHistory[0].clock, 10)-parseInt(zabbixItemHistory[i].clock, 10));
            // var B=(this.time_object[this.time_selection].time/this.time_object[this.time_selection].lquantity);
            // console.log("TOP:"+A)
            // console.log("DIV:"+B)
            if(i!=zabbixItemHistory.length-1 ){
              t1=parseInt(zabbixItemHistory[i].clock, 10);
              t2=parseInt(zabbixItemHistory[i+1].clock, 10);

              if((t1-t2)>time_step_int){
                // console.log("Add Zeros="+addZerosQuantity)
                var addZerosQuantity= Math.round( (t1-t2)/time_step_int);
                for(j=0;j<addZerosQuantity;j++){
                  swapclock=t2+(addZerosQuantity*time_step_int);

                  date = new Date((swapclock)*1000);
                  dateString=date.toLocaleString();
                  this.label_array.push(dateString);
                  this.value_array.push(null);
                }
              }
            }

            // if((parseInt(zabbixItemHistory[0].clock, 10)-parseInt(zabbixItemHistory[i].clock, 10))%(this.time_object[this.time_selection].time/this.time_object[this.time_selection].lquantity)==0  || i==zabbixItemHistory.length-1){
              date = new Date(zabbixItemHistory[i].clock*1000);
              dateString=date.toLocaleString();
            //   if(this.label_array[this.label_array.length-1]!=dateString){
                this.label_array.push(dateString);
            //     console.log("Label: "+dateString)
            //   }
            //   else{
            //     this.label_array.push("");
            //   }
            // }
            // else{
            //   this.label_array.push("");
            // }
            this.value_array.push(parseFloat(zabbixItemHistory[i].value));
          }
          // console.log(this.label_array);
          // console.log(this.value_array);
          date = new Date();
          // this.label_array.push(date.toLocaleString());
          // this.value_array.push(99);

          this.fillData();
          this.loading = false;


        });
      },
      selectChoice (choice){
        // console.log(choice);
        // this.loading = true;
        this.time_selection=choice;
        this.getUpdatedValues();
      },
      fillData () {
        this.datacollection = {
          labels: this.label_array,
          datasets: [
            {
              label: this.label,
              borderColor: "rgba(193, 42, 33, 1)",
              backgroundColor: "rgba(198, 169, 168, 1)",
              data: this.value_array
            }
          ]
        };
        this.options = {
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: false
                },
                gridLines: {
                  display: false
                }

              }],
              xAxes: [ {
                ticks: {
                  beginAtZero: false,
                  autoSkip: true,
                  maxTicksLimit: 6
                },
                gridLines: {
                  display: false
                }
              }]
            },
            elements: { point: { radius: 0 } },
            legend: {
              display: true
            },
            responsive: true,
            maintainAspectRatio: false
          };

      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
      }
    }
  };
</script>

<style>
  .small {
    height: calc(100% - 50px);
    max-width: 850px;
    width: calc(100% - 80px);
    margin:  80px auto;
    background-color: whitesmoke !important;

  }
</style>
